/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type AdminCell_lists$ref: FragmentReference;
declare export opaque type AdminCell_lists$fragmentType: AdminCell_lists$ref;
export type AdminCell_lists = {|
  +id: string,
  +$refType: AdminCell_lists$ref,
|};
export type AdminCell_lists$data = AdminCell_lists;
export type AdminCell_lists$key = {
  +$data?: AdminCell_lists$data,
  +$fragmentRefs: AdminCell_lists$ref,
  ...
};
*/


const node/*: ReaderFragment*/ = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "AdminCell_lists",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "type": "Lists"
};
// prettier-ignore
(node/*: any*/).hash = '4fa58c55aacce1b7e685e08e68156cb4';

module.exports = node;
